import React from 'react';
import { motion } from 'framer-motion';

const Slide09Gamification: React.FC = () => {
  const features = [
    { icon: '⭐', title: 'XP & Levels', desc: 'Earn points for every correct answer' },
    { icon: '🏆', title: 'Achievements', desc: 'Unlock badges for milestones' },
    { icon: '🔥', title: 'Streaks', desc: 'Build daily learning habits' },
    { icon: '📊', title: 'Progress', desc: 'Visual mastery tracking' },
    { icon: '🎮', title: 'Modes', desc: 'Practice, Challenge, Adventure' },
    { icon: '👥', title: 'Leaderboards', desc: 'Optional friendly competition' },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        Students Love Learning
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-2xl text-[#94a3b8] mb-12 text-center"
      >
        Gamification that motivates without distracting from learning
      </motion.p>

      <div className="grid grid-cols-3 gap-6 max-w-4xl">
        {features.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 + index * 0.08 }}
            className="rounded-xl p-6 text-center"
            style={{
              background: 'rgba(30, 41, 59, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}
          >
            <div className="text-5xl mb-4">{item.icon}</div>
            <h3 className="text-xl font-semibold text-white mb-2">{item.title}</h3>
            <p className="text-lg text-[#94a3b8]">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Slide09Gamification;
